import DataSet from "@antv/data-set";
import { Box } from "@mui/system";
import { Chart, Axis, Tooltip, Interval, Coord } from "bizcharts";
import { useEffect, useState } from "react";
import { usePapaParse } from "react-papaparse";
import DownloadButton from "../Common/DownloadButton";

const HistogramChart = (props) => {
    const [values, setValues] = useState([]);

    const csv = props.csv;
    const { readString } = usePapaParse();

    const handleReadString = () => {
        readString(csv, {
            complete: (results, file) => {
                setValues((prevState) => {
                    return results.data.map(d => d['Quantified results'])
                });
            },
            download: true,
            header: true,
            dynamicTyping: true,
            error: (error, file) => {
                console.log('Error while parsing:', error, file);
            },
        });
    };

    useEffect(() => {
        handleReadString();
    }, []);

    const data = [];

    for (let i = 0; i < values.length; i++) {
        const obj = {};
        obj.value = values[i];
        data.push(obj);
    }

    const ds = new DataSet();
    const dv = ds.createView().source(data);

    dv.transform({
        type: "bin.histogram",
        field: "value",
        binWidth: 2,
        as: ["value", "count"]
    });

    const cols = {
        value: {
            nice: false,
            min: 0,
            tickInterval: 1
        },
        count: {
            max: 70000
        }
    };

    const [canvas, setCanvas] = useState(undefined);

    return (
        <Box>
            <Box>
                <Chart
                    height={300}
                    data={dv.rows}
                    scale={cols}
                    autoFit
                    onGetG2Instance={chartInstance => {
                        setCanvas(chartInstance.canvas);
                    }}
                >
                    <Axis
                        name="value"
                        label={{
                            formatter: val => {
                                if (val % 2) {
                                    return val;
                                }

                                return "";
                            }
                        }}
                    />
                    <Axis name="count" />
                    <Tooltip inPlot={false} crosshairs={false} position={"top"} itemTpl={'<li style="padding: 10px 0" data-index={index}>'
                        + '<span style="background-color:#FFBB00;width:8px;height:8px;border-radius:50%;display:inline-block;margin-right:8px;"></span>'
                        + '{name}: {value}'
                        + '</li>'} />
                    <Interval position="value*count"
                        style={{
                            stroke: '#FFBB00',
                            fill: '#FFBB00',
                            fillOpacity: 1,
                            lineWidth: 1
                        }} />
                </Chart>
            </Box>
        </Box>
    );
}

export default HistogramChart;